"use strict";

exports.__esModule = true;
exports.TAG_TYPES = void 0;
var TAG_TYPES = {
  META: 'meta',
  SCRIPT: 'script',
  LINK: 'link',
  TITLE: 'title'
};
exports.TAG_TYPES = TAG_TYPES;